import { TFunction } from "i18next";

type SelectedLabelProp = { 
    labelText: string, 
    totalCount: number,
    selectedAll: boolean,
    handleSelectAll: () => void,
    t: TFunction
}

const SelectedLabel = ({ labelText, totalCount, selectedAll, handleSelectAll, t }: SelectedLabelProp) => {
    return <div className="phishing-step3__role-list-header">
        <div className="phishing-step3__label">
            {labelText}
            {totalCount > 0 ? (
                <>
                    <span className="phishing-step3__dot"> · </span>
                    <span className="phishing-step3__total-count">
                        {`${t(`phishingManager.campaignSetup.step3.countUser${totalCount > 1 ? "s" : ""}`, { count: totalCount })} ${t(`phishingManager.campaignSetup.step3.selected`)}`}
                        <span className="required"> * </span>
                    </span>
                </>
            ) : <span className="required"> * </span>}
        </div>
        {/* <button className="phishing-step3__select-all" onClick={handleSelectAll}>
            {selectedAll ? "Deselect all" : "Select all"}
        </button> */}
    </div>
}

export default SelectedLabel;